
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"4","cy":"10","r":"2","fill":"#0A0A0A"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"2","fill":"#0A0A0A"}}),_c('circle',{attrs:{"cx":"16","cy":"10","r":"2","fill":"#0A0A0A"}})])
          )
        }
      }
    